import { buildUrl } from '@/common-utils/functions/restUtils';
import { client } from '@/common-utils/libraries/axios/axios';
import HISTORICS from '../apiUrls';
import historicsFields from '../../fields/historicsFields';

/**
 * @param {Object} responseData
 * @param {Object[]} responseData.items
 * @param {number} responseData.totalPartialResults
 * @param {Object} responseData.extraInformation
 * @returns Mapped data object
 */
function mapResponseData({ items, totalPartialResults, extraInformation }) {
    const data = {};
    const mappedItems = items.map(item => ({
        [historicsFields.COMMON.UUID.key]: item[historicsFields.COMMON.UUID.key],
        [historicsFields.COMMON.ACTION_TIMESTAMP.key]: item[historicsFields.COMMON.ACTION_TIMESTAMP.key],
        [historicsFields.COMMON.ORGANIZATION_UUID.key]: item[historicsFields.COMMON.ORGANIZATION_UUID.key],
        [historicsFields.COMMON.ORGANIZATION_LEGAL_NAME.key]: item[historicsFields.COMMON.ORGANIZATION_LEGAL_NAME.key],
        [historicsFields.COMMON.ACTION_TYPE.key]: item[historicsFields.COMMON.ACTION_TYPE.key],
        [historicsFields.COMMON.USER_EMAIL.key]: item[historicsFields.COMMON.USER_EMAIL.key],
        [historicsFields.COMMON.ATTRIBUTES_VALUES_BEFORE.key]: item[historicsFields.COMMON.ATTRIBUTES_VALUES_BEFORE.key],
        [historicsFields.COMMON.ATTRIBUTES_VALUES_AFTER.key]: item[historicsFields.COMMON.ATTRIBUTES_VALUES_AFTER.key],
        [historicsFields.COMMON.OUTCOME.key]: item[historicsFields.COMMON.OUTCOME.key],
        [historicsFields.USERS_HISTORICS.EMAIL.key]: item[historicsFields.USERS_HISTORICS.EMAIL.key],
        [historicsFields.USERS_HISTORICS.TYPE.key]: item[historicsFields.USERS_HISTORICS.TYPE.key]
    }));

    data.items = mappedItems;
    data.totalPartialResults = totalPartialResults;
    data.extraInformation = extraInformation;

    return data;
}

const queryGetUsersHistorics = ({ query }, enabled) => {
    return {
        queryKey: [HISTORICS.USERS.COLLECTION.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(HISTORICS.USERS.COLLECTION.url, query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetUsersHistorics;